import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { logUserEvent } from 'fmc-digital-common';
import { selectSelectedLoanNumber } from '@store/selectors/widgets.selectors';
import { useCallback } from 'react';

const useLaunchpadNavigation = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const selectedLoanNumber = useSelector(selectSelectedLoanNumber);

    const handleLaunchpadNavigation = useCallback(() => {
        const launchpad = localStorage.getItem('launchpad');
        if (launchpad) {
            localStorage.removeItem('launchpad');
            try {
                logUserEvent({
                    type: 'Deeplink Routing',
                    action: `NavigatedTo${launchpad}`,
                    loanNumber: selectedLoanNumber?.identifier,
                    description: 'An event to capture dynamic deeplink routing'
                });
                navigate(launchpad);
            } catch (e) {
                //TODO: Added catch for no route present but this is not being triggered.
                console.error('Navigation error:', e);
                enqueueSnackbar('Navigation error occurred', { variant: 'error' });
            }
        }
    }, [enqueueSnackbar, navigate, selectedLoanNumber?.identifier]);

    return handleLaunchpadNavigation;
};

export default useLaunchpadNavigation;
